module.exports = __webpack_public_path__ + "img/23.33053783.png";